import { NumberType } from "../types.mjs";
import { findStopLessThanOrEqualTo } from "../stops.mjs";
//#region src/expression/definitions/step.ts
var Step = class Step {
	constructor(type, input, stops, key) {
		this.type = type;
		this.input = input;
		this.key = key;
		this.labels = [];
		this.outputs = [];
		for (const [label, expression] of stops) {
			this.labels.push(label);
			this.outputs.push(expression);
		}
	}
	static parse(args, context) {
		if (args.length - 1 < 4) return context.error(`Expected at least 4 arguments, but found only ${args.length - 1}.`);
		if ((args.length - 1) % 2 !== 0) return context.error("Expected an even number of arguments.");
		const input = context.parse(args[1], 1, NumberType);
		if (!input) return null;
		const stops = [];
		let outputType = null;
		if (context.expectedType && context.expectedType.kind !== "value") outputType = context.expectedType;
		for (let i = 1; i < args.length; i += 2) {
			const label = i === 1 ? -Infinity : args[i];
			const value = args[i + 1];
			const labelKey = i;
			const valueKey = i + 1;
			if (typeof label !== "number") return context.error("Input/output pairs for \"step\" expressions must be defined using literal numeric values (not computed expressions) for the input values.", labelKey);
			if (stops.length && stops[stops.length - 1][0] >= label) return context.error("Input/output pairs for \"step\" expressions must be arranged with input values in strictly ascending order.", labelKey);
			const parsed = context.parse(value, valueKey, outputType);
			if (!parsed) return null;
			outputType = outputType || parsed.type;
			stops.push([label, parsed]);
		}
		return new Step(outputType, input, stops, context.key);
	}
	evaluate(ctx) {
		const labels = this.labels;
		const outputs = this.outputs;
		if (labels.length === 1) return outputs[0].evaluate(ctx);
		const value = this.input.evaluate(ctx);
		if (value <= labels[0]) return outputs[0].evaluate(ctx);
		const stopCount = labels.length;
		if (value >= labels[stopCount - 1]) return outputs[stopCount - 1].evaluate(ctx);
		return outputs[findStopLessThanOrEqualTo(labels, value, this.key)].evaluate(ctx);
	}
	eachChild(fn) {
		fn(this.input);
		for (const expression of this.outputs) fn(expression);
	}
	outputDefined() {
		return this.outputs.every((out) => out.outputDefined());
	}
};
//#endregion
export { Step };

//# sourceMappingURL=step.mjs.map